import { useState } from 'react';
import api from '../../js/api';
import helpers from "../../js/helpers";
import { hasher } from "../../js/alpine/stores/hasher";
import shopifyHelper from "../../js/shopify";

const useCreateCustomer = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);
    const [customerId, setCustomerId] = useState(null);

    const getDetailsForm = async (id, auth) => {

        const body = JSON.stringify({
          query: hasher.store().getQuery('fetch'),
          variables: {
            customerId: `gid://shopify/Customer/${id}`,
          },
        });

        let data = {
          options: {
            method: "POST",
            headers: {
              "X-Shopify-Access-Token": "<SHOPIFY_API_AUTHENTICATED_KEY>",
              "Content-Type": "application/json",
              "X-MindArc-Hash": hasher.store().getHash('fetch'),
            },
            body: body,
            request_body:  hasher.store().getQuery('fetch'),
          },
        };

        let jsonResponse = null;
        if (auth) {
          jsonResponse = await shopifyHelper.authenticatedFetch(data);
        } else {
          jsonResponse = await shopifyHelper.unauthenticatedFetch(
            body,
            null,
            false,
          );
        }
        let metafieldsObjectData = {};
        
        if (jsonResponse.data.customer?.metafields.edges.length > 0) {
          const metaData = jsonResponse.data.customer?.metafields.edges;
          metafieldsObjectData = metaData.reduce((acc, item) => {
            const key = item.node.key;
            acc[key] = item.node.id;
            return acc;
          }, {});
        }

        return metafieldsObjectData;
    };
    const updateCustomerBirthDate = async (customerId, birthDate) => {
   
        const customerMetafields = await getDetailsForm(customerId, !api.isDevStore());

        const body = JSON.stringify({
          query: hasher.store().getQuery('update'),
          variables: {
            input: {
              id: `gid://shopify/Customer/${customerId}`,
              metafields: [ 
                {
                    id: customerMetafields["birthdate"],
                    value: birthDate,
                }
              ],
            },
          },
        });

        let data = {
          options: {
            method: "POST",
            headers: {
              "X-Shopify-Access-Token": "<SHOPIFY_API_AUTHENTICATED_KEY>",
              "Content-Type": "application/json",
              "X-MindArc-Hash": hasher.store().getHash('update'),
            },
            body: body,
            request_body: hasher.store().getQuery('update'),
          },
        };
        let jsonResponse = null;
        if (api.isDevStore()) {
            jsonResponse = await shopifyHelper.unauthenticatedFetch(
            body,
            null,
            false,
          );
        
        } else {
              jsonResponse = await shopifyHelper.authenticatedFetch(data);
        }

    };


    const createCustomer = async (formData, auth = false) => {
        setLoading(true);
        setError(null);
        setSuccess(null);
        setCustomerId(null);
  
        const year = formData?.birthdayYear;
        const month = formData?.birthdayMonth;
        const day = formData?.birthdayDay;
        
        // Create date with the required format
        const date = year && month && day ? 
            new Date(parseInt(year), parseInt(month) - 1, parseInt(day)).toString()
            : 'None';
             
        // Prepare metafields for later update
        const metafieldArray = [
            {
                namespace: "custom",
                key: "business_name",
                value: formData.business_name ? formData.business_name : 'None',
            },
            {
                namespace: "custom",
                key: "birthdate",
                value: date,
            },
            {
                namespace: "custom",
                key: "ABN",
                value: formData.abn ? formData.abn.toString() : '0',
            },
            {
                namespace: "custom",
                key: "role",
                value: formData.role ? formData.role : 'None',
            },
            {
                namespace: "custom",
                key: "Industry",
                value: formData.Industry ? formData.Industry : 'None',
            },
            {
                namespace: "custom",
                key: "gift_frequency",
                value: formData.gift_frequency ? formData.gift_frequency : 'None' ,
            },
            {
                namespace: "custom",
                key: "common_gift_recipient",
                value: formData.common_gift_recipient ? formData.common_gift_recipient : 'None',
            },
            {
                namespace: "custom",
                key: "company_size",
                value: formData.company_size ? formData.company_size : 'None',
            },
            {
                namespace: "custom",
                key: "website",
                value: formData.website ? formData.website : 'None',
            },
        ].filter((item) => item.value != null);

        let firstName = formData.first_name || '';
        let lastName = formData.last_name || '';
    
        
        // Prepare marketing consent data for later updates
        const hasOptInSMS = formData.optInSMS && formData.phone;
        const hasOptInEmail = formData.optInEmail;
        
        // Log the input values for debugging
        console.log('Create Customer Input:', {
            email: formData.email,
            firstName,
            lastName,
            phone: formData.phone,
            password: formData.password ? '********' : undefined,
            acceptsMarketing: hasOptInEmail
        });

        // Track signup event
        window.braze?.logCustomEvent("Sign-up",
            {
              "first name": firstName,
              "last name": lastName,
              "email": formData.email,
              "phone": formData.phone || null,
              "business name": formData.business_name || 'None',
              "industry": formData.Industry || 'None',
              "subscribed to email": hasOptInEmail,
              "subscribed to sms": hasOptInSMS
            });
        
        try {
            // For development store, continue using REST API approach
            if (api.isDevStore()) {
                const restPayload = {
                    customer: {
                        email: formData.email,
                        first_name: firstName,
                        last_name: lastName,
                        phone: formData.phone,
                        password: formData.password,
                        password_confirmation: formData.password_confirmation,
                        tags: "hook",
                        metafields: metafieldArray,
                        sms_marketing_consent: hasOptInSMS ? {
                            state: "subscribed",
                            opt_in_level: "single_opt_in"
                        } : undefined,
                        email_marketing_consent: hasOptInEmail ? {
                            state: "subscribed",
                            opt_in_level: "single_opt_in"
                        } : undefined
                    }
                };
                
                const response = await fetch(`${helpers.getDomain()}/admin/api/2024-07/customers.json`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Shopify-Access-Token': api.getPublicAccessToken(),
                    },
                    body: JSON.stringify(restPayload),
                });
    
                const jsonResponse = await response.json();
    
                if (!response.ok) {
                    let errorMessage = '';
                    console.error('Failed to create customer', jsonResponse);
                    Object.keys(jsonResponse.errors).forEach((key) => {
                        if (["phone", "email"].includes(key)) {
                            errorMessage += `${key} ${jsonResponse.errors[key].join(", ")}\n`;
                        } else {
                            errorMessage += `Error: ${jsonResponse.errors[key].join(", ")}\n`;
                        }
                    });
                    throw new Error(jsonResponse.errors ? errorMessage : 'Failed to create customer');
                }
                
                console.info('Customer created Data', jsonResponse);
                setCustomerId(jsonResponse.customer.id);
                console.info('Customer created', customerId);
                setSuccess(true);
                return jsonResponse.customer.id;
            }
            
            const createCustomerQuery = auth ? hasher.store().getQuery('create-customer-admin') : hasher.store().getQuery('create-customer-storefront');
     
            const createBody = JSON.stringify({
                query: createCustomerQuery,
                variables: {
                    input: {
                        email: formData.email,
                        firstName,
                        lastName,
                        phone: formData.phone || undefined,
                        ...(formData.password && { password: formData.password }),
                        ...(!auth && { acceptsMarketing: Boolean(hasOptInEmail) }) 
                    }
                }
            });
            
            let createResponse = null;

            if (auth) {  
            const data = {
                options: {
                    method: "POST",
                    headers: {
                        "X-Shopify-Access-Token": "<SHOPIFY_API_AUTHENTICATED_KEY>",
                        "Content-Type": "application/json",
                        "X-MindArc-Hash": hasher.store().getHash('create-customer-admin'),
                    },
                    body: createBody,
                    request_body: hasher.store().getQuery('create-customer-admin'),
                }
            };
            
            createResponse = await shopifyHelper.authenticatedFetch(data);
            } else {
            createResponse = await shopifyHelper.unauthenticatedFetch(
                createBody,
                null,
                true,
                true
            );
            }
            
            console.log('Create Customer Response:', createResponse);
            
            // Handle errors from customer creation
            if (createResponse.data?.customerCreate?.userErrors?.length > 0) {
                const errors = createResponse.data.customerCreate.userErrors;
                let errorMessage = '';
                
                errors.forEach(error => {
                    if (["phone", "email"].includes(error.field)) {
                        errorMessage += `${error.field} ${error.message}\n`;
                    } else {
                        errorMessage += `Error: ${error.message}\n`;
                    }
                });
                
                throw new Error(errorMessage || 'Failed to create customer');
            }
            
            if (createResponse.errors) {
                throw new Error('Failed to create customer: ' + JSON.stringify(createResponse.errors[0]?.message));
            }
            
            // Extract the new customer ID
            const rawCustomerId = createResponse.data.customerCreate.customer.id;
            const customerIdNumber = rawCustomerId.split('/').pop();
            setCustomerId(customerIdNumber);
            console.info('Customer created with ID:', customerIdNumber);

            // STEP 2: Update metafields using update query
            const updateQuery = hasher.store().getQuery('update');
            
            // Wait briefly to ensure customer is fully created in Shopify's system
            await new Promise(resolve => setTimeout(resolve, 500));
            
            const updateBody = JSON.stringify({
                query: updateQuery,
                variables: {
                    input: {
                        id: `gid://shopify/Customer/${customerIdNumber}`,
                        metafields: metafieldArray
                    }
                }
            });
            
            const updateData = {
                options: {
                    method: "POST",
                    headers: {
                        "X-Shopify-Access-Token": "<SHOPIFY_API_AUTHENTICATED_KEY>",
                        "Content-Type": "application/json",
                        "X-MindArc-Hash": hasher.store().getHash('update'),
                    },
                    body: updateBody,
                    request_body: updateQuery,
                }
            };
            
            const updateResponse = await shopifyHelper.authenticatedFetch(updateData);
            console.log('Update Metafields Response:', updateResponse);
            
            // Check for errors in the metafields update
            if (updateResponse.data?.customerUpdate?.userErrors?.length > 0) {
                console.error('Warning: Failed to update metafields', updateResponse.data.customerUpdate.userErrors);
                // Continue even if metafields fail, as the customer was already created
            }
            
            // STEP 3a: Update email marketing consent if needed
            if (hasOptInEmail) {
                const emailConsentQuery = hasher.store().getQuery('update-email');
                const emailConsentBody = JSON.stringify({
                    query: emailConsentQuery,
                    variables: {
                        input: {
                            customerId: `gid://shopify/Customer/${customerIdNumber}`,
                            emailMarketingConsent: {
                                marketingState: "SUBSCRIBED",
                                marketingOptInLevel: "SINGLE_OPT_IN"
                            }
                        }
                    }
                });
                
                const emailConsentData = {
                    options: {
                        method: "POST",
                        headers: {
                            "X-Shopify-Access-Token": "<SHOPIFY_API_AUTHENTICATED_KEY>",
                            "Content-Type": "application/json",
                            "X-MindArc-Hash": hasher.store().getHash('update-email'),
                        },
                        body: emailConsentBody,
                        request_body: emailConsentQuery,
                    }
                };
                
                const emailConsentResponse = await shopifyHelper.authenticatedFetch(emailConsentData);
                console.log('Update Email Consent Response:', emailConsentResponse);
            }
            
            // STEP 3b: Update SMS marketing consent if needed
            if (hasOptInSMS && formData.phone) {
                const smsConsentQuery = hasher.store().getQuery('update-sms');
                const smsConsentBody = JSON.stringify({
                    query: smsConsentQuery,
                    variables: {
                        input: {
                            customerId: `gid://shopify/Customer/${customerIdNumber}`,
                            smsMarketingConsent: {
                                marketingState: "SUBSCRIBED",
                                marketingOptInLevel: "SINGLE_OPT_IN"
                            }
                        }
                    }
                });
                
                const smsConsentData = {
                    options: {
                        method: "POST",
                        headers: {
                            "X-Shopify-Access-Token": "<SHOPIFY_API_AUTHENTICATED_KEY>",
                            "Content-Type": "application/json",
                            "X-MindArc-Hash": hasher.store().getHash('update-sms'),
                        },
                        body: smsConsentBody,
                        request_body: smsConsentQuery,
                    }
                };
                
                const smsConsentResponse = await shopifyHelper.authenticatedFetch(smsConsentData);
                console.log('Update SMS Consent Response:', smsConsentResponse);
            }
            
            console.info('Customer creation and updates complete');
            setSuccess(true);
            
            return customerIdNumber;
        } catch (error) {
            const errorMessage = error.message;
            switch(true){
                case errorMessage.includes('already been taken'):
                    setError( 'Email or phone number already taken');
                break;
                default:
                    setError(error.message || "Error occurred while creating the customer");
                break;
            }
        } finally {
            setLoading(false);
        }
    };


    return {
        createCustomer,
        updateCustomerBirthDate,
        loading,
        error,
        success,
        customerId,
    };
};

export default useCreateCustomer;
